import { dispatch } from "@rematch/core";
import { getOrderStatus } from "utils/interface";
import { CQ } from "utils/commonQuest";

// 订单状态
export const orderStatus = {
  state: {},
  effects: {
    // 获取订单状态数据
    async getOrderStatus(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getPrimaryCategories);
      const data = await CQ(getOrderStatus());
      dispatch["share"].updateOrdreStatus(data);
    }
  }
};
